import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import SignUpSvg from "../assets/sign_up_svg.png";
import {
  BadgeOutlined,
  CheckCircle,
  Email,
  EmailOutlined,
  Lock,
  LockOutlined,
} from "@mui/icons-material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useGeolocated } from "react-geolocated";
import { getPhoneCode } from "libphonenumber-js";
import { serverURL } from "../App";
import NewLogo from "../assets/new_logo.png";
import InputField from "../Components/Input1";

const SignUpPage = () => {
  const [error, setError] = useState();
  const [signInForm, setSignInForm] = useState(true);
  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    password: "", // Default country code
    confirm_password: "",
  });
  const [notification, setNotification] = useState(false);
  const [notificationForgetPassword, setNotificationForgetPassword] =
    useState(false);
  const [successScreen, setSuccessScreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [promptMsg, setPromptMsg] = useState("");
  const [groupData, setGroupData] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const forgotPassword = async () => {
    if (!data.email) {
      setError("Email is required");
      return;
    }
    if (!data.email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
      setError("Invalid email format");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post("/users/forgotPassword", {
        email: data.email,
      });
      if (res.data.success) {
        // setSuccessScreen(true);
        setNotificationForgetPassword(true);
        setTimeout(() => {
          setNotificationForgetPassword(false);
        }, 3000);
        setLoading(false);
      } else {
        setLoading(false);
        setError(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getQrInfo = async (qr_uuid) => {
    const response = await axios({
      method: "get",
      url: "/qrCards/qrCodeData/" + qr_uuid,
    });
    if (response.data.success) {
      let { group_name = "" } = response.data.result;
      setGroupData(response.data.result);
      setPromptMsg(
        `You are about to add in ${
          +response.data.result?.qr_type === 3 ? "RSVP" : "Group"
        } ${group_name}`
      );
    }
  };
  const param = useParams();

  const DownloadVcf = async (data) => {
    // Create the VCF content
    const vCardData = `
BEGIN:VCARD
VERSION:3.0
FN:${data.first_name} ${data.last_name}
TEL;TYPE=CELL:${data.phone_number}
EMAIL:${data.email}
END:VCARD`;

    // Create a blob from the VCF data
    const blob = new Blob([vCardData], { type: "text/vcard" });

    // Create a link element
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "contact.vcf"; // The file name to download

    // Trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (param.user_code) {
      getUserData(param.user_code);
    } else if (param.group_uuid) {
      getGroupData(param.group_uuid);
    } else if (param.qr_uuid) {
      getQrInfo(param.qr_uuid);
    }
    // handleDownload();
  }, [param.group_uuid, param.qr_uuid, param.user_code]);

  const getGroupData = async (group_uuid) => {
    const response = await axios({
      method: "get",
      url: "/groups/getGroupByInfo?group_uuid=" + group_uuid,
    });
    if (response.data.success) {
      let { group_name = "" } = response.data.result;
      setPromptMsg(`You are about to join: ${group_name}`);
      setGroupData(response.data.result);
    }
  };
  const getUserData = async (user_code) => {
    const response = await axios({
      method: "post",
      url: "/users/getUsersData",
      data: {
        user_uuid: user_code,
        filters: ["first_name", "last_name", "email", "phone_number"],
        qr_uuid: param.templete_uuid,
      },
    });
    if (response.data.success) {
      setGroupData(response.data.result);
      setPromptMsg(`You are about to connect`);
    }
  };

  const signUp = async () => {
    if (
      !data.first_name ||
      !data.last_name ||
      !data.email ||
      !data.phone_number ||
      !data.password
    ) {
      setError("All fields are required");
      return;
    }
    if (data.password !== data.confirm_password) {
      setError("Password does not match");
      return;
    }
    //check email format
    if (!data.email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
      setError("Invalid email format");
      return;
    }
    if (data.password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post("/users/SignUpWithContact", {
        ...data,
        user_code: param.user_code || groupData.user_code,
        group_uuid: groupData.group_uuid,
        qr_uuid: param.qr_uuid || param.templete_uuid,
        shared_by: searchParams.get("shared_by"),
      });

      if (res.data.success) {
        DownloadVcf(res.data.result);

        setData();
        setSuccessScreen(true);
        setNotification(true);
        setTimeout(() => {
          setNotification(false);
          if (groupData.redirection_url) {
            window.location.href = groupData.redirection_url;
          }
        }, 3000);
      } else {
        setError(res.data.message);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const signIn = async () => {
    if (!data.email || !data.password) {
      setError("All fields are required");
      return;
    }

    if (!data.email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
      setError("Invalid email format");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post("/users/SignInWithContact", {
        ...data,
        user_code: param.user_code || groupData.user_code,
        group_uuid: groupData.group_uuid,
        qr_uuid: param.qr_uuid || param.templete_uuid,
        shared_by: searchParams.get("shared_by"),
      });
      if (res.data.success) {
        DownloadVcf(res.data.result);

        setData();
        setSuccessScreen(true);
        setNotification(true);
        setTimeout(() => {
          setNotification(false);
          if (groupData.redirection_url) {
            window.location.href = groupData.redirection_url;
          }
        }, 3000);
      } else {
        setLoading(false);
        setError("Incorrect email and password");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const { coords } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: true,
    },
    userDecisionTimeout: 5000,
  });

  useEffect(() => {
    console.log(coords, signInForm);
    if (coords && !signInForm) {
      const fetchCountryCode = async () => {
        try {
          const response = await axios.get(
            `https://api.bigdatacloud.net/data/reverse-geocode-client`,
            {
              params: {
                latitude: coords.latitude,
                longitude: coords.longitude,
                localityLanguage: "en",
              },
            }
          );
          // setCountryCode(response.data.countryCode);
          console.log(response.data, getPhoneCode(response.data.countryCode));
          let code = getPhoneCode(response.data.countryCode);
          setData({ ...data, country_code: code, phone_number: code });
        } catch (error) {
          setError("Failed to fetch country code.");
        }
      };

      fetchCountryCode();
    }
  }, [coords, signInForm]);

  console.log(data);
  return (
    <div
      className="sign_up_page"
      style={{ paddingTop: "0px", position: "relative", overflowX: "hidden" }}
    >
      <div className="three-corner-curve-new"></div>
      <div className="sign_up_page_header">
        <div
          className="sign_up_svg flex"
          style={{
            padding: "0",
            alignItems: "start",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          <img src={NewLogo} alt="" className="new_logo_style" />
          <div className="sign_up_page_header_text">
            {signInForm ? "Login" : "Signup"}
          </div>
        </div>

        <div className="sign_up_svg">
          <img src={SignUpSvg} alt="" className="sign_up_svg_img" />
        </div>
      </div>
      <div className="sign_up_page_header_text_2">
        Welcome{signInForm ? " back" : ""}! Please enter your details.
      </div>

      {notification ? (
        <div className="success_dialogue">
          <div className="success_dialogue_icon">
            <CheckCircle />
          </div>
          <div className="success_dialogue_heading">
            User Added Successfully
          </div>
        </div>
      ) : (
        ""
      )}
      {notificationForgetPassword ? (
        <div className="success_dialogue">
          <div className="success_dialogue_icon">
            <CheckCircle />
          </div>
          <div className="success_dialogue_heading">
            Email sent successfully
          </div>
        </div>
      ) : (
        ""
      )}

      {/* {successScreen ? ( */}
      <div
        className="play_store_container"
        style={{
          position: "fixed",
          bottom: successScreen ? "20px" : "100vh",
        }}
      >
        {groupData ? (
          groupData?.group_uuid ? (
            <>
              <img
                src={groupData.group_image}
                style={{ width: "100px" }}
                alt="group_image"
              />

              <div className="sign_up_form_heading">
                You are now added in {groupData.group_name}
              </div>
            </>
          ) : param.user_code ? (
            <div className="sign_up_form_heading">
              You are Successfully connected with {groupData.first_name}{" "}
              {groupData.last_name}
            </div>
          ) : (
            ""
          )
        ) : (
          ""
        )}
        <div
          className="flex"
          style={{
            justifyContent: "space-between",
            width: "350px",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <PlayStoreButton />
          <AppStoreButton />
        </div>
        {groupData ? (
          groupData?.group_uuid ? (
            <>
              <button
                onClick={() =>
                  DownloadVcf({
                    first_name: groupData.group_name,
                    last_name: "",
                    email: groupData.email,
                    phone_number: groupData.phone_number,
                  })
                }
                className="vcf_button"
              >
                Download Group Contact
              </button>
            </>
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
      {/* ) :  */}
      {successScreen ? (
        <></>
      ) : signInForm ? (
        <div className="sign_up_form_body">
          <div
            className="sign_up_form_heading"
            style={{
              flexDirection: "column",
              marginTop: "0px",
              background: "#E4F5FF",
              fontSize: "12px",
              lineHeight: "20px",
              borderRadius: "10px",
              paddingTop: "0",
              width: "320px",
            }}
          >
            {/* {promptMsg}{" "} */}
            {!groupData.group_uuid ? (
              <div
                style={{ color: "black", marginTop: "10px", fontWeight: "500" }}
              >
                <div style={{ display: "flex" }}>
                  <div style={{ fontWeight: "700", minWidth: "20%" }}>
                    Name:
                  </div>{" "}
                  {groupData?.first_name} {groupData?.last_name}
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ fontWeight: "700", minWidth: "20%" }}>
                    Phone:
                  </div>{" "}
                  {groupData?.phone_number}
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ fontWeight: "700", minWidth: "20%" }}>
                    Email:
                  </div>{" "}
                  {groupData?.email}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

          {/* <div className="sign_up_form_heading" style={{ marginTop: "5vh" }}>
            Sign In
          </div>
          <div className="sign_up_form">
            <div className="input-wrapper">
              <input
                type="email"
                placeholder="Email"
                value={data.email}
                onChange={(e) => setData({ ...data, email: e.target.value })}
              />
              {data.email && (
                <span
                  className="clear-icon"
                  onClick={() => setData({ ...data, email: "" })}
                >
                  &times;
                </span>
              )}
            </div>

            <div className="input-wrapper">
              <input
                type="password"
                placeholder="Password"
                value={data.password}
                onChange={(e) => setData({ ...data, password: e.target.value })}
              />
              {data.password && (
                <span
                  className="clear-icon"
                  onClick={() => setData({ ...data, password: "" })}
                >
                  &times;
                </span>
              )}
            </div>
            
          </div> */}
          <div style={{ padding: "2rem 10px" }} className="sign_up_form_new">
            <InputField
              type="email"
              placeholder="Email"
              icon={<EmailOutlined />}
              onChange={(e) => setData({ ...data, email: e.target.value })}
              value={data.email}
            />
            <br />
            <InputField
              type="password"
              placeholder="Password"
              showToggle={true}
              icon={<LockOutlined />}
              onChange={(e) => setData({ ...data, password: e.target.value })}
              value={data.password}
            />
            {error ? <p style={{ color: "red" }}>{error}</p> : ""}
            <p onClick={forgotPassword} className="doNotHaveAcc">
              <span>Forgot Password?</span>
            </p>
            {loading ? (
              <button id="loading-screen">
                <svg viewBox="0 0 100 100">
                  <path
                    d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                    fill="#ffffff"
                    stroke="none"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      dur="1s"
                      repeatCount="indefinite"
                      keyTimes="0;1"
                      values="0 50 51;360 50 51"
                    ></animateTransform>
                  </path>
                </svg>
              </button>
            ) : (
              <button onClick={signIn}>Sign In</button>
            )}
            <p onClick={() => setSignInForm(false)} className="doNotHaveAcc">
              Don't have an account <span>Sign Up</span>
            </p>
          </div>
        </div>
      ) : (
        <div className="sign_up_form_body">
          {/* <div className="sign_up_form_heading" style={{ marginTop: "5vh" }}>
            Sign Up
          </div> */}
          {/* <div className="sign_up_form">
            <div className="input-wrapper">
              <input
                type="text"
                placeholder="First Name"
                value={data.first_name}
                onChange={(e) =>
                  setData({ ...data, first_name: e.target.value })
                }
              />
              {data.first_name && (
                <span
                  className="clear-icon"
                  onClick={() => setData({ ...data, first_name: "" })}
                >
                  &times;
                </span>
              )}
            </div>
            <div className="input-wrapper">
              <input
                type="text"
                placeholder="Last Name"
                value={data.last_name}
                onChange={(e) =>
                  setData({ ...data, last_name: e.target.value })
                }
              />
              {data.last_name && (
                <span
                  className="clear-icon"
                  onClick={() => setData({ ...data, last_name: "" })}
                >
                  &times;
                </span>
              )}
            </div>
            <div className="input-wrapper">
              <input
                type="email"
                placeholder="Email"
                value={data.email}
                onChange={(e) => setData({ ...data, email: e.target.value })}
              />
              {data.email && (
                <span
                  className="clear-icon"
                  onClick={() => setData({ ...data, email: "" })}
                >
                  &times;
                </span>
              )}
            </div>
            <div className="input-wrapper">
              <PhoneInput
                country={"us"} // Default country code
                value={data.phone_number}
                onChange={(phone, country) => {
                  setData({
                    ...data,
                    phone_number: phone,
                    country_code: country.dialCode,
                  });
                }}
                inputStyle={{
                  width: "250px",

                  marginBottom: "1rem",
                  border: "none",
                  borderRadius: "5px",
                  boxShadow: "none",
                  height: "30px",
                  fontSize: "1rem",
                }}
              />
              {data.phone_number && (
                <span
                  className="clear-icon"
                  onClick={() => setData({ ...data, phone_number: "" })}
                >
                  &times;
                </span>
              )}
            </div>
            <div className="input-wrapper">
              <input
                type="password"
                value={data.password}
                placeholder="Password"
                onChange={(e) => setData({ ...data, password: e.target.value })}
                style={{ marginBottom: "20px" }}
              />
              {data.password && (
                <span
                  className="clear-icon"
                  onClick={() => setData({ ...data, password: "" })}
                >
                  &times;
                </span>
              )}
            </div>
            <div className="input-wrapper">
              <input
                type="password"
                value={data.confirm_password}
                placeholder="Confirm Password"
                onChange={(e) =>
                  setData({ ...data, confirm_password: e.target.value })
                }
              />
              {data.confirm_password && (
                <span
                  className="clear-icon"
                  onClick={() => setData({ ...data, confirm_password: "" })}
                >
                  &times;
                </span>
              )}
            </div>

            {loading ? (
              <button id="loading-screen">
                <svg viewBox="0 0 100 100">
                  <path
                    d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                    fill="#ffffff"
                    stroke="none"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      dur="1s"
                      repeatCount="indefinite"
                      keyTimes="0;1"
                      values="0 50 51;360 50 51"
                    ></animateTransform>
                  </path>
                </svg>
              </button>
            ) : (
              <button onClick={signUp}>Sign Up</button>
            )}
            {error ? <p style={{ color: "red" }}>{error}</p> : ""}
            <p onClick={() => setSignInForm(true)} className="doNotHaveAcc">
              Have an account <span>SignIn</span>
            </p>
          </div> */}
          <div style={{ padding: "2rem 10px" }} className="sign_up_form_new">
            <InputField
              type="text"
              placeholder="First Name"
              onChange={(e) => setData({ ...data, first_name: e.target.value })}
              value={data.first_name}
              icon={<BadgeOutlined/>}
            />
            <br />
            <InputField
              type="text"
              placeholder="Last Name"
              onChange={(e) => setData({ ...data, last_name: e.target.value })}
              value={data.last_name}
              icon={<BadgeOutlined />}
            />
            <br />
            <InputField
              type="email"
              placeholder="Email"
              icon={<EmailOutlined />}
              onChange={(e) => setData({ ...data, email: e.target.value })}
              value={data.email}
            />
            <br />
            <PhoneInput
              country={"us"} // Default country code
              value={data.phone_number}
              onChange={(phone, country) => {
                setData({
                  ...data,
                  phone_number: phone,
                  country_code: country.dialCode,
                });
              }}
              inputStyle={{
                width: "300px",

                // marginBottom: "1rem",
                border: "none",
                borderRadius: "15px",
                boxShadow: "none",
                height: "28px",
                fontSize: "14px",
              }}
            />
            <br />
            <InputField
              type="password"
              value={data.password}
              placeholder="Password"
              showToggle={true}
              icon={<LockOutlined />}
              onChange={(e) => setData({ ...data, password: e.target.value })}
            />
            <br />
            <InputField
              type="password"
              value={data.confirm_password}
              placeholder="Confirm Password"
              showToggle={true}
              icon={<LockOutlined />}
              onChange={(e) =>
                setData({ ...data, confirm_password: e.target.value })
              }
            />
            <br />
            {error ? <p style={{ color: "red" }}>{error}</p> : ""}
            {loading ? (
              <button id="loading-screen">
                <svg viewBox="0 0 100 100">
                  <path
                    d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                    fill="#ffffff"
                    stroke="none"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      dur="1s"
                      repeatCount="indefinite"
                      keyTimes="0;1"
                      values="0 50 51;360 50 51"
                    ></animateTransform>
                  </path>
                </svg>
              </button>
            ) : (
              <button onClick={signUp}>Sign Up</button>
            )}

            <p onClick={() => setSignInForm(true)} className="doNotHaveAcc">
              Have an account <span>SignIn</span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignUpPage;
const PlayStoreButton = () => (
  <a
    href={serverURL + "playStoreLink"}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="https://api.synkoria.com/images/playstore.png"
      alt="play store"
      style={{ width: "150px", marginRight: "25px" }}
    />
  </a>
);

const AppStoreButton = () => (
  <a
    href={serverURL + "appStoreLink"}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="https://api.synkoria.com/images/appstore.png"
      alt="app store"
      style={{ width: "150px" }}
    />
  </a>
);
